import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=76fecbec&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=ts"
export * from "./SocialLogin.vue?vue&type=script&lang=ts"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=76fecbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fecbec",
  null
  
)

export default component.exports